module.exports = __webpack_public_path__ + "img/InviteRules.9feadca7.png";